import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { DialogHost, installDialogs } from "./components/common/dialogs";
import { store } from "./app/store";
import AppRouter from "./routes/index";
import "./index.css";
import { applyTheme, getTheme } from "./utils/theme";
import { installRequiredAlert } from "./utils/formErrors";

applyTheme(getTheme());

// Browser alert() now opens the styled dialog (success messages become toasts).
installDialogs(toast);
installRequiredAlert();   // one alert listing every empty required field (browser "required" bubbles are easy to miss)

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
      <DialogHost />
      <Toaster
        position="top-center"
        gutter={10}
        toastOptions={{
          duration: 3500,
          className: "app-toast",
          style: {
            background: "#fff",
            color: "#1E3A5F",
            fontSize: "13.5px",
            fontWeight: 600,
            borderRadius: "12px",
            border: "1px solid #E2E8F0",
            padding: "12px 14px",
          },
          success: { iconTheme: { primary: "#059669", secondary: "#fff" }, style: { borderLeft: "4px solid #059669" } },
          error: { iconTheme: { primary: "#DC2626", secondary: "#fff" }, style: { borderLeft: "4px solid #DC2626" }, duration: 5000 },
        }}
      />
    </Provider>
  </React.StrictMode>
);
